import { Injectable } from '@angular/core';
import { Step } from '../shared/step.model';

@Injectable({
  providedIn: 'root',
})
export class StepsService {

  getSteps(loanPurpose: string): Step[] {

    loanPurpose = loanPurpose.toLowerCase();
    if (loanPurpose === 'airatefinder') {
      return [new Step('loanPurpose')];
    }

    const allSteps = {
      refinance: [
        new Step('propertyType'),
        new Step('propertyTypeConfirmation', 'propertyTypeConfirmation'),
        new Step('propertyUse'),
        // new Step('bankruptcy'),
        // new Step('selfEmployed'),
        new Step('maximumEquity', 'maximumEquity'),
        new Step('cashOut', 'showCashOut'),
        new Step('cashOutReason', 'cashOutReason'),
        new Step('propertyValue'),
        new Step('firstMortgageBalance'),
        new Step('currentFHA'),
        new Step('creditRating'),
        new Step('zipCodeStreetAddress'),
        new Step('veteranMilitary'),
        new Step('currentVA', 'currentVA'),
        new Step('firstNameLastName'),
        // new Step('lendersCount'),
        new Step('email', null, 'setBackgroundImage'),
        new Step('phone'),
        new Step('neustar', 'neustar')
      ],
      purchase: [
        new Step('propertyType'),
        new Step('propertyTypeConfirmation', 'propertyTypeConfirmation'),
        new Step('propertyUse'),
        // new Step('bankruptcy'),
        // new Step('bankruptcy-recency', 'bankruptcyRecency'),
        // new Step('selfEmployed'),
        new Step('buyingProcess'),
        new Step('newHomeValue'),
        new Step('creditRating'),
        new Step('estimatedDownPayment'),
        new Step('zipCode'),
        new Step('veteranMilitary'),
        new Step('firstTimeBuyer'),
        new Step('firstNameLastName'),
        // new Step('lendersCount'),
        new Step('email', null, 'setBackgroundImage'),
        new Step('phone'),
        new Step('neustar', 'neustar')
      ],
      personalloan: [
        new Step('loanPurpose'),
        new Step('cashOut'),
        new Step('creditRating'),
        new Step('timeFrame', 'propertyStatus'),
        new Step('zipCodeStreetAddress'),
        new Step('propertyStatus', 'propertyStatus'),// old key: 'propertyUse',
        new Step('propertyValue', 'housingSituationIsOwn'),
        new Step('firstMortgageBalance', 'housingSituationIsOwn'),
        // new Step('selfEmployed'),
        new Step('bankruptcy'),
        new Step('veteranMilitary', 'housingSituationIsOwn'),
        new Step('currentVA', 'currentVA'),
        new Step('firstNameLastName'),
        new Step('email', null, 'setBackgroundImage'),
        new Step('phone'),
        new Step('neustar', 'neustar')
      ],
      pl: [
        new Step('creditRating'),
        new Step('propertyStatus', 'propertyStatus'),
        new Step('firstNameLastName'),
        new Step('email', null, 'setBackgroundImage'),
        new Step('phone'),
        new Step('neustar', 'neustar')
      ]
    };

    return allSteps[loanPurpose];
  }
}
